/**
 * @generated SignedSource<<e1478820539014a69617375fc9aac18f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArchiveList_component$data = {
  readonly archiveTitle: string | null | undefined;
  readonly detailfilter: {
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilter_detailFilter">;
  } | null | undefined;
  readonly documents: ReadonlyArray<{
    readonly date: string | null | undefined;
    readonly doctypeheader: string | null | undefined;
    readonly header: string | null | undefined;
    readonly text: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ArchiveFileLink_archiveFileLink">;
  } | null | undefined> | null | undefined;
  readonly filterbuttontext: string | null | undefined;
  readonly filterbuttontextexpanded: string | null | undefined;
  readonly livefilter: {
    readonly " $fragmentSpreads": FragmentRefs<"LiveFilter_liveFilter">;
  } | null | undefined;
  readonly noresultstext: string | null | undefined;
  readonly yearLabel: string | null | undefined;
  readonly " $fragmentType": "ArchiveList_component";
};
export type ArchiveList_component$key = {
  readonly " $data"?: ArchiveList_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArchiveList_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArchiveList_component",
  "selections": [
    {
      "alias": "archiveTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "yearLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveFilter",
      "kind": "LinkedField",
      "name": "livefilter",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LiveFilter_liveFilter"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilter",
      "kind": "LinkedField",
      "name": "detailfilter",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DetailFilter_detailFilter"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ArchiveFileLink",
      "kind": "LinkedField",
      "name": "documents",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ArchiveFileLink_archiveFileLink"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "doctypeheader",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noresultstext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterbuttontext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterbuttontextexpanded",
      "storageKey": null
    }
  ],
  "type": "ArchiveList",
  "abstractKey": null
};

(node as any).hash = "eccccb29b9ba04ef225cef0f6d3177e8";

export default node;
